// Feature flags.
//
// ANALYTICS_ENABLED gates the FEATURE-002 analytics UI everywhere it surfaces:
//   1. Home — the earnings hero state + the Dashboard earnings widgets
//   2. Menu — the "Analytics" section entry + the /analytics route
//   3. Client info — the per-client "Analytics" tab
//
// false = hidden (prod, until analytics is prod-verified). Flip to true for
// staging / launch. Backend is unaffected — the earnings endpoint and the
// Wait→Done completion cron keep running; only the UI is hidden.
export const ANALYTICS_ENABLED = false;
